import { render, staticRenderFns } from "./PrimaryContactDropdown.vue?vue&type=template&id=dd72bc0c&scoped=true&"
import script from "./PrimaryContactDropdown.vue?vue&type=script&lang=js&"
export * from "./PrimaryContactDropdown.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryContactDropdown.vue?vue&type=style&index=0&id=dd72bc0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd72bc0c",
  null
  
)

export default component.exports